<template lang="pug">
.wrapperOverlay
    img.imageOverlay.scaleIframe(:style="getScaling()"  v-if="overlay.imageUrl"  :src="overlay.imageUrl")
    div.scaleIframe(:style="getScaling()" v-html="`${getHtml}`")
</template>

<script>
import urlFormat from "@/utils/urlFormat";
import { mapState } from "vuex";

export default {
  name: "OverlayPreview",
  data() {
    return {};
  },

  props: ["overlay", "windowSize"],

  computed: {
    ...mapState({
      selectedTheme: (state) => state.create.selectedTheme,
    }),
    getHtml() {
      if (!this.overlay) return "";
      const { params, htmlTemplate, fontBase64 } = this.overlay;
      if (!htmlTemplate || !params) return "";

      if (
        params
          .filter((param) => !param.key.startsWith("BRANDING_"))
          .every((param) => !param.value || param.value === "")
      ) {
        return "";
      }

      // Quick fix to use theme colors instead of branding colors
      const { primaryColor, accentColor } = this.selectedTheme;
      if (primaryColor) {
        const i = params.findIndex(
          (param) => param.key === "BRANDING_PRIMARY_COLOR"
        );
        if (i > -1) params[i].value = primaryColor;
      }

      if (accentColor) {
        const i = params.findIndex(
          (param) => param.key === "BRANDING_ACCENT_COLOR"
        );
        if (i > -1) params[i].value = accentColor;
      }

      let html = htmlTemplate;

      const templateOverwritingParam = params.find(
        (param) => param.overwriteTemplate
      );

      if (templateOverwritingParam) {
        html =
          templateOverwritingParam.templates[templateOverwritingParam.value];
      }

      params.forEach(
        (param) =>
          (html = this.setTemplateParam(
            html,
            param.key,
            param.value ?? param.defaultValue
          ))
      );

      html = this.setTemplateParam(
        html,
        "BRANDING_FONT_BASE64",
        fontBase64 ?? this.selectedTheme.fontBase64
      );

      html = this.setTemplateParam(
        html,
        "LOGO_LIGHT",
        this.selectedTheme.logoLightUrl
      );

      html = this.setTemplateParam(
        html,
        "LOGO_DARK",
        this.selectedTheme.logoDarkUrl
      );

      return html;
    },
  },
  methods: {
    ...urlFormat,

    getScaling() {
      let scaleWide = 0.3578125;
      const chosenWidth = 1920;
      const chosenHeight = 1080;
      if (this.windowSize.width > 0) {
        scaleWide = this.windowSize.width / chosenWidth;
      }

      // const scaleWide = 0.3578125;
      return `
      width: ${chosenWidth}px;
      height: ${chosenHeight}px;
      transform: scale(${scaleWide});
      -webkit-transform: scale(${scaleWide});
      -moz-transform: scale(${scaleWide});
      -o-transform: scale(${scaleWide});
      transform: scale(${scaleWide});`;
    },
    setTemplateParam(str, find, replace) {
      const key = "{" + find + "}";
      return str.replace(new RegExp(key, "g"), replace ?? "");
    },
  },
};
</script>
<style lang="sass" scoped>
@import '@/assets/style/variables'
.wrapperOverlay
    position: absolute
.imageOverlay
    position: absolute
    top: 0px
    left: 0px
    right: 0px
    bottom: 0px
    width: 100%
.scaleIframe
    width: 1920px
    height: 1080px
    transition: all 0.3 ease
    transform-origin: left bottom
    -webkit-transform-origin: left bottom
    -moz-transform-origin: left bottom
.overlays
    position: absolute
    top: 0
    bottom: 0
    display: flex
    justify-content: flex-start
    align-items: flex-end
</style>
